import type { TranslationKey } from "../i18n/translations";
import { useLocale } from "../i18n/LocaleContext";
import { PagedListControls } from "./PagedListControls";
import type { ClientListRecord } from "./useClientRecordList";
import { useClientRecordList } from "./useClientRecordList";

export function ClientRecordListControls<T extends ClientListRecord>({
  list,
  statusLabel,
  formatStatus,
}: {
  list: ReturnType<typeof useClientRecordList<T>>;
  statusLabel?: TranslationKey;
  formatStatus?: (status: string) => string;
}) {
  const { t, formatNumber } = useLocale();
  return (
    <PagedListControls
      applyLabel={t("recordList.applyFilters")}
      clearLabel={t("recordList.clearFilters")}
      rowsPerPageLabel={t("recordList.rowsPerPage")}
      previousLabel={t("recordList.previousPage")}
      nextLabel={t("recordList.nextPage")}
      pageLabel={t("recordList.pageOf")}
      totalLabel={t("recordList.totalRecords")}
      page={list.page}
      pageSize={list.pageSize}
      totalCount={list.totalCount}
      formatNumber={formatNumber}
      filters={
        <>
          <label>
            <span>{t("nav.search")}</span>
            <input
              value={list.query}
              onChange={(event) => list.setQuery(event.target.value)}
              placeholder={t("recordList.search")}
            />
          </label>
          {list.statusOptions.length > 0 && (
            <label>
              <span>{t(statusLabel ?? "administration.status")}</span>
              <select
                value={list.statusFilter}
                onChange={(event) => list.setStatusFilter(event.target.value)}
              >
                <option value="">{t("recordList.allStatuses")}</option>
                {list.statusOptions.map((value) => (
                  <option key={value} value={value}>
                    {formatStatus?.(value) ?? value}
                  </option>
                ))}
              </select>
            </label>
          )}
        </>
      }
      onApply={list.apply}
      onClear={list.clear}
      onPageChange={list.changePage}
      onPageSizeChange={list.changePageSize}
    />
  );
}
